import { type DefaultRootState } from 'react-redux';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type Draft } from 'immer';
import { type AppKey, type CompanyKey } from '@bbkAdminRedux/app/reducers';

type ActiveContext = {
  activeCompanyKey?: CompanyKey;
  activeAppKey?: AppKey;
};

type AppState = ActiveContext & {
  loadedNecessaryData: boolean;
};

const initialState: AppState = {
  loadedNecessaryData: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    initializeActiveContext: (
      state: Draft<AppState>,
      action: PayloadAction<ActiveContext>
    ) => {
      state.activeCompanyKey = action.payload.activeCompanyKey;
      state.activeAppKey = action.payload.activeAppKey;
      state.loadedNecessaryData = true;
    },
    clearActiveContext: (state: Draft<AppState>) => {
      state.activeCompanyKey = undefined;
      state.activeAppKey = undefined;
    },
  },
});

export const selectAppState = (state: DefaultRootState) => state.app;

export const selectActiveCompanyKey = (state: DefaultRootState) =>
  selectAppState(state).activeCompanyKey;

export const selectActiveAppKey = (state: DefaultRootState) =>
  selectAppState(state).activeAppKey;
